import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { matchPath, Outlet, useLocation } from 'react-router';
import Header from '~/components/Header';
import { getPageTitle } from '~/config/pageTitles';
import { useEnsureLanguage } from '~/hooks/useEnsureLanguage';
import dealershipQuery from '~/queries/dealershipQuery';
import { Link, useParams } from '~/router';

export default function Layout() {
  // In this file we know the transactionId, and in turn, we understand the the language
  // of the user.
  const { transactionId, dealershipSlug } = useParams(
    '/dashboard/:dealershipSlug/:transactionId'
  );
  const { t } = useTranslation();
  const location = useLocation();
  const dealership = useQuery(
    dealershipQuery(dealershipSlug ? { dealershipSlug } : undefined)
  );
  const isOnDashboard = matchPath(
    { path: '/dashboard/:dealershipSlug/:transactionId', end: true },
    location.pathname
  );

  useEnsureLanguage(transactionId, dealershipSlug);

  return (
    <div>
      <Header
        title={getPageTitle({
          path: location.pathname,
          t,
          search: location.search,
          dealershipName: dealership.data?.dealership?.name ?? 'TDC'
        })}
        leftElement={
          isOnDashboard ? (
            <div className="relative">
              <img src="/logo.png" className="h-4" aria-label="Logo" />
            </div>
          ) : (
            <Link
              to="/dashboard/:dealershipSlug/:transactionId"
              params={{ dealershipSlug, transactionId }}
              className="link-small"
            >
              {location.pathname.includes('glove-compartment')
                ? t('Close')
                : t('Cancel')}
            </Link>
          )
        }
      />

      <Outlet />
    </div>
  );
}
